import React from 'react';
import {
  PricingStrategy,
  ProductCardVariant,
  ProductVariant,
} from '@zonofi/zono-money-store';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { PriceInfoTooltip } from '../../components';

interface ProductMetaProps {
  variant: ProductCardVariant;
  product: ProductVariant;
  price: number;
}

export const ProductMeta: React.FC<ProductMetaProps> = ({
  variant,
  product,
  price,
}) => {
  return (
    <div className="product-price-view">
      {variant !== ProductCardVariant.ADD_TO_OFFLINE_CART && (
        <span className="title title-color font-medium">{'Price: '}</span>
      )}
      <span className="title price-color font-semibold">
        {getFormattedAmount(price)}
      </span>
      {variant !== ProductCardVariant.ADD_TO_OFFLINE_CART &&
        product?.pricingStrategy !== PricingStrategy.STANDARD && (
          <PriceInfoTooltip
            title={'Computed Price'}
            subText={
              <>quantity × price = {getFormattedAmount(product?.price)}</>
            }
            heading={`(${getFormattedAmount(product?.price)})`}
          />
        )}

      {/* {(variant === ProductCardVariant.ORDER_ADD ||
        variant === ProductCardVariant.ORDER_REPLACE ||
        variant === ProductCardVariant.ORDER_MAP) && (
        <>
          <span className="dot-view">{'•'}</span>
          <span className="title title-color font-medium">{'Margin:'}</span>
          <span className="title margin-color font-medium">
            {getFormattedAmount(product?.PTR - product?.price)}
          </span>
        </>
      )} */}
    </div>
  );
};
